import React from 'react';
import cn from 'classnames';
import { FormWrapperMobile } from '@alfa-bank/site-form-wrapper/mobile';
import styles from '@alfa-bank/site-form-wrapper/src/desktop/styles.css';

import { Form } from '../../../form';
import type { IForm } from '../../../models';

/** Адаптер рамки формы, чтобы убрать рамку из Form */
export const FormWrapperAdapter = ({
    className,
    fill,
    hideWrapper,
    /**
     * для обратной совместимости
     * в SmeFrom на мобилке можно делать тень
     */
    isShadowEnabled = true,
    ...proxyProps
}: IForm) => {
    if (!hideWrapper) {
        return (
            <FormWrapperMobile
                className={cn(className, { [styles.formWrapperShadow]: isShadowEnabled })}
                fill={fill}
            >
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <Form {...proxyProps} />
            </FormWrapperMobile>
        );
    }

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Form className={className} {...proxyProps} />;
};
